import { useMutation } from 'react-query';
import zfServices from './zf.services';
import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { WORKORDER_COMPLEMENT_DETAIL_KEY } from '../WorkOrdersComplements/WorkOrdersComplements.hooks';
import notificationError from '@/utils/functions/notificationError';

export function useWorkOrderZfGenerateToken() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: zfServices.generateToken,
    onSuccess(token, complementId) {
      if (token) {
        notification.success({
          message: 'Redirecionando para o Marketplace da ZF Pro[Parts]',
        });

        queryChanel({
          invalidateQueries: [[WORKORDER_COMPLEMENT_DETAIL_KEY, complementId]],
        });

        const anchor = document.createElement('a');
        anchor.href = `${process.env.REACT_APP_ZF_URL}/access-token/${token}`;
        anchor.target = '_blank';

        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
      } else {
        notification.error({
          message:
            'Não foi possível gerar o token de redirecionamento para Marketplace da ZF Pro[Parts]',
          duration: 6,
        });
      }
    },
    onError(error) {
      notificationError(error);
    },
  });
}
